import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex align-items-center gap-3" }
const _hoisted_3 = { class: "p-fluid flex-grow-1" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "text-sm font-mono"
}
const _hoisted_7 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_8 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_Entries = _resolveComponent("Entries")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('postback_url')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FieldText, { "model-value": _ctx.postbackUrl }, null, 8, ["model-value"])
        ]),
        _withDirectives(_createVNode(_component_IconPark, {
          class: "mb-3 cursor-pointer",
          type: "copy",
          theme: "outline",
          size: "18",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.postbackUrl)))
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('copy'),
            void 0,
            { top: true }
          ]
        ])
      ])
    ]),
    _createVNode(_component_Entries, {
      title: _ctx.$t('conversions'),
      "show-add-button": false,
      "href-prefix": "postbacks"
    }, {
      tables: _withCtx(() => [
        _createVNode(_component_EntriesDataTable, {
          entries: _ctx.postbacks,
          "entries-handler": _ctx.fetchPostbacksWrapper,
          "show-actions-column": false,
          "href-prefix": "postbacks"
        }, {
          columns: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, {
              field: "id",
              header: "ID",
              sortable: ""
            }),
            (_ctx.user.isSuperAdmin())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 0,
                  field: "project_id",
                  header: _ctx.$t('project'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.project)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(data.project.name), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("—")
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (!_ctx.user.isAffiliate())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 1,
                  field: "user_id",
                  header: _ctx.$t('advertiser'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.user)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `/users/${data.user_id}`,
                          target: "_blank"
                        }, _toDisplayString(data.user.email), 9, _hoisted_4))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("—")
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimeVueColumn, {
              field: "ad_id",
              header: _ctx.$t('campaign'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                (data.campaign)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `/campaigns/${data.ad_id}`,
                      target: "_blank"
                    }, _toDisplayString(data.campaign.name), 9, _hoisted_5))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("—")
                    ], 64))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "raw_event",
              header: "Event"
            }, {
              body: _withCtx(({ data }) => [
                (data.event)
                  ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                      key: 0,
                      value: _ctx.POSTBACK_EVENTS_MAP[data.event].label,
                      severity: _ctx.POSTBACK_EVENTS_MAP[data.event].severity
                    }, null, 8, ["value", "severity"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(data.raw_event || '—'), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_PrimeVueColumn, {
              field: "payout",
              header: _ctx.$t('payout'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$n(data.payout, 'payout')), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "status",
              header: _ctx.$t('status'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_PrimeVueTag, {
                  value: _ctx.POSTBACK_STATUSES_MAP[data.status].label,
                  severity: _ctx.POSTBACK_STATUSES_MAP[data.status].severity
                }, null, 8, ["value", "severity"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "created_at",
              header: _ctx.$t('created_at'),
              sortable: ""
            }, null, 8, ["header"])
          ]),
          _: 1
        }, 8, ["entries", "entries-handler"])
      ]),
      filters: _withCtx(() => [
        (_ctx.user.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.postbacksFilters.project_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postbacksFilters.project_id) = $event)),
                label: _ctx.$t('project'),
                "show-clear": "",
                loading: _ctx.projectsLoading,
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name"
              }, null, 8, ["modelValue", "label", "loading", "options"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.user.isStaff())
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_FieldDropdownAutoComplete, {
                modelValue: _ctx.postbacksFilters.user_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postbacksFilters.user_id) = $event)),
                name: "user_id",
                label: _ctx.$t('user'),
                "show-clear": "",
                "api-url": "/api/v3/users/options",
                "api-params": _ctx.usersParams,
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "label", "api-params"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_FieldDropdownAutoComplete, {
            modelValue: _ctx.postbacksFilters.campaign_id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.postbacksFilters.campaign_id) = $event)),
            label: _ctx.$t('campaign'),
            "show-clear": "",
            "api-url": "/api/v3/campaigns/options",
            "api-params": _ctx.campaignsParams,
            "option-label": "compiled_name"
          }, null, 8, ["modelValue", "label", "api-params"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.postbacksFilters.status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postbacksFilters.status) = $event)),
            label: _ctx.$t('status'),
            "show-clear": "",
            options: _ctx.POSTBACK_STATUSES
          }, null, 8, ["modelValue", "label", "options"])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}